import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import request, { isSalesManager, isSalesSupport } from '../../utils/request';
import { contentfulFormConfig, getFormStepFields } from '../../contentful';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';
import OrderDetails from '../../orderDetails';

const ViewOrder = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { viewOrderButtonLabel }
  } = localizedStrings;

  const { id, locale } = orderData;
  const userRights = {
    isStatusEditable: false,
    canAssignOrder: false,
    canAddComments: false,
    canPerformAction: false
  };

  const [isOderDetailsOpen, setIsOrderDetailsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [orderSummary, setOrderSummary] = useState(null);
  const [orderComments, setOrderComments] = useState(null);

  const handleViewOrder = async () => {
    setIsLoading(true);
    const {
      data: { results: comments }
    } = await request.get(`/orders/${id}/comments`);
    setOrderComments(comments);

    const config = { ...contentfulFormConfig, locale };
    getFormStepFields(config, summary => {
      setOrderSummary(summary);
      setIsLoading(false);
      setIsOrderDetailsOpen(true);
    });
  };

  return (
    <>
      <Spinner
        fullScreen={isLoading}
        label="Loading order details.."
        show={isLoading}
      />
      {orderSummary && (
        <div className="view-order-summary">
          <OrderDetails
            open={isOderDetailsOpen}
            setOpen={setIsOrderDetailsOpen}
            order={orderData}
            userRights={userRights}
            comments={orderComments}
            summary={orderSummary}
            isSalesManager={isSalesManager}
            isSalesSupport={isSalesSupport}
          />
        </div>
      )}
      <Button className="action-button" onClick={handleViewOrder}>
        {viewOrderButtonLabel}
      </Button>
    </>
  );
};

ViewOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrder;
